import { BLOCK_CLASSES } from '@intercom/composer-ember/lib/blocks/constants';
export const codeBlockSpec = {
  inline: false,
  content: '(hardBreak | text | inline)*',
  attrs: {
    type: {
      default: 'code'
    }
  },
  defining: true,
  group: 'block',
  parseDOM: [{
    tag: 'pre'
  }],
  toDOM() {
    return ['pre', {
      class: `${BLOCK_CLASSES.code}`
    }, 0];
  },
  marks: ''
};